export default __webpack_public_path__ + "static/media/Tutorial-Step-2.5.e330e484.jpg";